// extracted by mini-css-extract-plugin
module.exports = {"root":"sign-in-form_root__jhFfB","icon":"sign-in-form_icon__Lv8Og","actions":"sign-in-form_actions__m2pbJ"};